import {ProgressBar as Bar, Item} from './ProgressBar'

export type {ProgressBarProps} from './ProgressBar'

/**
 * Collection of ProgressBar related components.
 */
export const ProgressBar = Object.assign(Bar, {Item})
